import React from 'react';

import Button from './../styled/Button';
import Icon from './../styled/Icon';

import Input from './Input';

const defaultState = {
  openInput: false,
  code: '',
  dangerous: false,
};

class Dialogue extends React.Component {
  constructor(props) {
    super(props);

    this.embedCode = this.embedCode.bind(this);
    this.resetState = this.resetState.bind(this);
    this.updateCode = this.updateCode.bind(this);
    this.updateDangerous = this.updateDangerous.bind(this);

    this.state = defaultState;
  }

  embedCode() {
    const { editor } = this.props;
    const { code, dangerous } = this.state;

    const block = {
      type: dangerous ? 'code' : 'iframe',
      isVoid: true,
      data: { code },
    };

    editor.change(change => {
      if (this.isCodeBlock()) {
        change.setBlocks(block);
      } else {
        change.insertBlock(block).insertBlock('paragraph');
      }
    });
    // 👇 This is necessary to miss React's render tick
    setTimeout(() => {
      editor.focus();
      this.resetState();
    }, 0);
  }

  resetState() {
    this.setState(defaultState);
  }

  getCurrentBlock() {
    const { editor } = this.props;
    return editor.value.blocks.get(0);
  }

  isCodeBlock() {
    const { type } = this.getCurrentBlock();
    return type === 'code' || type === 'iframe';
  }

  isDangerous() {
    const { type } = this.getCurrentBlock();
    return type === 'code';
  }

  updateCode(code) {
    this.setState({ code: code });
  }

  updateDangerous() {
    this.setState(prev => ({dangerous: !prev.dangerous}));
  }

  render() {
    return (
      <div>
        <Button
          active={this.props.editor && this.isCodeBlock()}
          onMouseDown={() => {
            const currentBlock = this.getCurrentBlock();
            this.setState({
              openInput: true,
              code: this.isCodeBlock() ?
                currentBlock.data.get('code') : '',
              dangerous: this.isDangerous(),
            });
          }}
        >
          <Icon className='fas fa-code' />
        </Button>

        <Input
          open={this.state.openInput}
          reset={() => {
            this.props.editor.focus();
            this.resetState();
          }}
          code={this.state.code}
          dangerous={this.state.dangerous}
          updateCode={this.updateCode}
          updateDangerous={this.updateDangerous}
          embedCode={this.embedCode}
        />
      </div>
    );
  }
}

export default Dialogue;
